/**
 * @file: StoreFeatureGate.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { StoreFeature } from '@euler/model/enum';
import { memo, ReactNode } from 'react';
import { FeatureNotEnabledView } from './FeatureNotEnabledView';

/**
 * A screen of one feature: its content when the store has it, else the
 * "not enabled" view, so a deep link to a missing feature lands somewhere.
 */
export const StoreFeatureGate = memo(
  ({ feature, children }: { feature: StoreFeature; children: ReactNode }) => {
    const { enabled } = useStoreFeature(feature);
    return enabled ? (
      <>{children}</>
    ) : (
      <FeatureNotEnabledView feature={feature} />
    );
  },
);
